import { render } from "./ButtonReturn.vue?vue&type=template&id=5c8c9b56&scoped=true"
import script from "./ButtonReturn.vue?vue&type=script&lang=js"
export * from "./ButtonReturn.vue?vue&type=script&lang=js"

import "./ButtonReturn.vue?vue&type=style&index=0&id=5c8c9b56&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c8c9b56"]])

export default __exports__